import { render } from "./modal-method-verification.vue?vue&type=template&id=2145faf0&ts=true"
import script from "./modal-method-verification.vue?vue&type=script&lang=ts"
export * from "./modal-method-verification.vue?vue&type=script&lang=ts"

import "./modal-method-verification.vue?vue&type=style&index=0&id=2145faf0&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__